module.exports = "<app-container></app-container>"